import { useMemo } from 'react';

import { Skeleton, Stack, Typography } from '@mui/material';

import Card from '@/components/card/Card';
import CreatorAccount from '@/components/creatorAccount';
import InstagramIcon from '@/components/icons/InstagramIcon';
import TikTokIcon from '@/components/icons/TikTokIcon';
import YoutubeIcon from '@/components/icons/YoutubeIcon';
import { Creator } from '@/models/creator';

const tilesMap = {
  instagram: (
    <>
      <InstagramIcon fontSize="medium" />
      <Typography variant="subtitle1">Instagram Accounts</Typography>
    </>
  ),
  tiktok: (
    <>
      <TikTokIcon fontSize="medium" />
      <Typography variant="subtitle1">Tiktok Accounts</Typography>
    </>
  ),
  youtube: (
    <>
      <YoutubeIcon fontSize="medium" />
      <Typography variant="subtitle1">Youtube Accounts</Typography>
    </>
  )
};

const Accounts = ({
  accounts,
  isLoading
}: {
  accounts?: Creator.DetailsAccounts;
  isLoading: boolean;
}) => {
  const platforms = useMemo(
    () =>
      (Object.keys(accounts ?? {}) as Creator.PlatformOptions[]).filter(
        (platform) => accounts && accounts[platform].length > 0
      ),
    [accounts]
  );

  return (
    <Stack direction="row" gap={2} id="creators-accounts-list">
      {isLoading ? (
        <Skeleton
          sx={{ marginBottom: 2 }}
          variant="rectangular"
          width="100%"
          height={200}
        />
      ) : (
        platforms.map((platform) => (
          <Card
            key={platform}
            title={
              <Stack direction="row" alignItems="center" gap={1}>
                {tilesMap[platform]}
              </Stack>
            }
            sx={{
              marginBottom: '16px',
              height: 'fit-content',
              flexBasis: '100%'
            }}
            content={
              <Stack gap={2}>
                {accounts?.[platform].map((account, index) => (
                  <CreatorAccount
                    key={`${platform}-${index}`}
                    account={account}
                    showBorderBottom={
                      index !== (accounts?.[platform].length ?? 0) - 1
                    }
                  />
                ))}
              </Stack>
            }
          />
        ))
      )}
    </Stack>
  );
};

export default Accounts;
